export default "__VITE_ASSET__b14596f5__"